import { render, staticRenderFns } from "./reglamentos.vue?vue&type=template&id=d670c632&scoped=true"
import script from "./reglamentos.vue?vue&type=script&lang=js"
export * from "./reglamentos.vue?vue&type=script&lang=js"
import style0 from "./reglamentos.vue?vue&type=style&index=0&id=d670c632&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d670c632",
  null
  
)

export default component.exports